import { render, staticRenderFns } from "./TitlePage.vue?vue&type=template&id=6c0a4dbe&scoped=true"
import script from "./TitlePage.vue?vue&type=script&lang=js"
export * from "./TitlePage.vue?vue&type=script&lang=js"
import style0 from "./TitlePage.vue?vue&type=style&index=0&id=6c0a4dbe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a4dbe",
  null
  
)

export default component.exports